












import Vue from "vue";
import {Component, Prop} from "vue-property-decorator";
import ApexRadialChart from "@/components/layout/charts/radial/ApexRadialChart.vue";
import DoughnutChart from "@/components/layout/charts/radial/DoughnutChart.vue";

@Component({
  components: {
    "apex-radial-chart": ApexRadialChart,
    "doughnut-chart": DoughnutChart,
  },
})
export default class RadialChart extends Vue {
  @Prop({ default: () => 0 })
  private readonly value!: number;

  private get percent(): number {
    let percent!: number;
    if (this.value >= 100) {
      percent = 100;
    }
    return percent;
  }

  @Prop({ default: () => 240 })
  private readonly radius!: number;

  @Prop()
  private readonly title!: string;

  @Prop({
    default: () => 30,
    validator: (value: number) => {
      return value > 0 && value < 100;
    },
  })
  private readonly hollowSize!: number;
}
